const awsmobile = {
  aws_project_region: "us-east-1",
  aws_appsync_region: "us-east-1",
  aws_appsync_graphqlEndpoint:
    "https://erky3zyl55b4ja2ygdf7r7rg4u.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_region: "us-east-1",
  aws_appsync_apiKey: "da2-fdih2px72vb57klgwadlbyxiji",
  aws_cognito_identity_pool_id:
    "us-east-1:95bb9c82-5477-4e54-96dd-6474bbab220a",
  aws_user_pools_id: "us-east-1_IUmo7ja76",
  aws_cognito_region: "us-east-1",
  aws_user_pools_web_client_id: "en7fdfivgdr30ctrab594hqkl",
  aws_cloud_logic_custom: [
    {
      name: "AdminQueries",
      endpoint: "https://fb9s6u9xh5.execute-api.us-east-1.amazonaws.com/admin",
      region: "us-east-1"
    }
  ],
  oauth: {},
  aws_user_files_s3_bucket: "pnp-merchant-storage-prod",
  aws_user_files_s3_bucket_region: "us-east-1"
};

export default awsmobile;
